import { Observable } from 'rxjs';
import { ValidaEdicionResponse } from '../interfaces/valida-edicion-paso-tres-response';

export abstract class ValidacionEdicionService {


  abstract getValidacionEdicion(): Observable<ValidaEdicionResponse>;


}
